import 'css-chunksrc/client/pages/projectPage/budgetPage/plannedBudget/styles.scss';export default {
  "plannedBudget": "_plannedBudget_1uxp3_1",
  "row": "_row_1uxp3_10",
  "group": "_group_1uxp3_16",
  "label": "_label_1uxp3_24",
  "value": "_value_1uxp3_32",
  "input": "_input_1uxp3_38",
  "tableHeader": "_tableHeader_1uxp3_57",
  "smallLabel": "_smallLabel_1uxp3_64",
  "tableSubHeader": "_tableSubHeader_1uxp3_81",
  "tableBody": "_tableBody_1uxp3_108",
  "warning": "_warning_1uxp3_132",
  "icon": "_icon_1uxp3_136"
};